import { fadeInAnimation, font, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type { Milliseconds } from '@lemonade-hq/ts-helpers';
import styled, { keyframes } from 'styled-components';

export const StyledLogo = styled.img.attrs({ alt: 'logo' })`
  width: 100%;
  height: 100%;
`;

export const AnimationTitle = styled.h1`
  color: ${themedColor('metal')};
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  ${MEDIA_QUERIES.desktop`
        ${font('main', { fontSize: '1.6rem', fontWeight: 400 })};
    `}
  ${MEDIA_QUERIES.upToDesktop`
        ${font('main', { fontSize: '1.4rem', fontWeight: 400 })};
    `}
`;

// ANIMATION GROUPS
export const ANIMATION_END_DELAY_BEFORE_REDIRECT: Milliseconds = 1000;

const textSlideIn = keyframes`
    0% {
        opacity: 0;
        transform: translateX(40px);
    }

    100% {
        opacity: 1;
        transform: translateX(0px);
    }
`;

export const AnimationGroup = styled.div`
  ${MEDIA_QUERIES.desktop`
        height: 255px;
    `}
  ${MEDIA_QUERIES.upToDesktop`
        height: 171px;
    `}

  --first-logo-duration: 800ms;
  --text-delay: 100ms;
  --text-duration: 400ms;
  --second-logo-delay: 100ms;
  --second-logo-duration: 600ms;
`;

export const FirstLogoWrapper = styled.div`
  animation-name: ${fadeInAnimation};
  animation-duration: var(--first-logo-duration);
  animation-timing-function: ease-in;
  animation-fill-mode: both;

  width: 186px;
  ${MEDIA_QUERIES.desktop`
        height: 100px;
    `}
  ${MEDIA_QUERIES.upToDesktop`
        height: 90px;
    `}
`;

export const FirstLogoWrapperWithHeart = styled.div`
  animation-name: ${fadeInAnimation};
  animation-duration: var(--first-logo-duration);
  animation-delay: calc(var(--first-logo-duration) + var(--text-delay));
  animation-timing-function: ease-in;
  animation-fill-mode: both;

  width: 186px;
  ${MEDIA_QUERIES.desktop`
        height: 100px;
    `}
  ${MEDIA_QUERIES.upToDesktop`
        height: 90px;
    `}
`;

export const AnimationTitleWrapper = styled.div`
  animation-name: ${textSlideIn};
  animation-delay: calc(var(--first-logo-duration) + var(--text-delay));
  animation-duration: var(--text-duration);
  animation-timing-function: ease-in;
  animation-fill-mode: both;

  ${MEDIA_QUERIES.desktop`
        margin: 25px 0;
    `}
  ${MEDIA_QUERIES.upToDesktop`
        margin: 20px 0;
    `}
`;

export const AnimationHeartWrapper = styled.div`
  animation-name: ${fadeInAnimation};
  animation-duration: var(--text-duration);
  animation-timing-function: ease-in;
  animation-fill-mode: both;

  ${MEDIA_QUERIES.desktop`
        margin: 25px 0;
    `}
  ${MEDIA_QUERIES.upToDesktop`
        margin: 20px 0;
    `}
`;

export const SecondLogoWrapper = styled.div.attrs({ 'aria-label': 'second logo wrapper' })`
  animation-name: ${fadeInAnimation};
  animation-delay: calc(
    var(--first-logo-duration) + var(--text-delay) + var(--text-duration) + var(--second-logo-delay)
  );
  animation-duration: var(--second-logo-duration);
  animation-timing-function: ease-in;
  animation-fill-mode: both;

  height: 45px;
  margin: 0 auto;
  ${MEDIA_QUERIES.desktop`
        width: 186px;
    `}
  ${MEDIA_QUERIES.upToDesktop`
        width: 171px;
    `}
`;
